import React from 'react';

export default class Page6 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt">
                                    <div className="innerpadding">
                                        <div className="ilead-contentarea">
                                            <div className="lightgreencontentbg lightbgcenter">
                                                <ul className="greenbullet-list">
                                                    <li className="line-height1"><span
                                                        className="green font-sep"><b>Strengths</b></span> –
                                                        what are the strengths that will assist you?
                                                    </li>
                                                    <li className="line-height1"><span
                                                        className="green green font-sep"><b>Weaknesses</b></span> –
                                                        which weaknesses of your own might hinder you?
                                                    </li>
                                                    <li className="line-height1"><span
                                                        className="green green font-sep"><b>Opportunities</b></span> –
                                                        what opportunities will result from it?
                                                    </li>
                                                    <li className="line-height1 cntareap"><span
                                                        className="green green font-sep"><b>Threats</b></span> –
                                                        what might threaten its success?
                                                    </li>
                                                </ul>
                                            </div>
                                            <br/>
                                            <p>The SWOT analysis is the first stage of planning and will
                                                help you make your objectives more specific, for
                                                example:</p>
                                            <div className="lightgreencontentbg lightbgcenter">
                                                <ul className="greenbullet-list">
                                                    <li className="line-height1">A strength could be
                                                        your specialist expertise.
                                                    </li>
                                                    <li className="line-height1">A weakness could be the
                                                        lack of a new product.
                                                    </li>
                                                    <li className="line-height1">An opportunity could be
                                                        a new or developing market.
                                                    </li>
                                                    <li className="cntareap line-height1">A threat could
                                                        be a new competitor in your home market.
                                                    </li>
                                                </ul>
                                            </div>
                                            <br/>
                                            <p>We’ve given you a Balancing Risk Worksheet on the
                                                next page – just fill in the boxes. It’s simple and
                                                surprisingly effective in helping you see the
                                                ‘trees’ in the wood!</p>
                                            <div className="border_subtitle">SWOT – Stage one</div>
                                            <p>Once you have analysed your potential course of
                                                action, assess the importance of each element.
                                                Invent your own rating scale. It only needs to be
                                                meaningful to you, so could be from –50 to +50,
                                                where –50 is very negative and +50 is very positive.
                                                For example:</p>
                                            <div className="paraspace"><p><b>Course of action:
                                                Moving jobs</b></p></div>
                                            <ul className="greenbullet-list">
                                                <li className="line-height1">I will get more
                                                    opportunity for career progression +30
                                                </li>
                                                <li className="line-height1"
                                                    style={{paddingBottom:'15px !important'}}>I will
                                                    not enjoy the amount of travelling involved -20
                                                </li>
                                            </ul>
                                            <div className="border_subtitle">SWOT – Stage two</div>
                                            <p>Once you’ve rated each course of action, add up the
                                                total for each column and enter it in the ‘total’
                                                boxes. Then add up the two positive aspects
                                                (strengths + opportunities) and put this in the
                                                ‘total’ box of the ‘positive’ column. Do the same
                                                for the negative aspects (weaknesses + threats).</p>
                                            <p>Now, you can see how balanced your decision is by
                                                comparing your total ‘positive’ and ‘negative’
                                                scores. In other words, do the strengths and
                                                opportunities outweigh the weaknesses and
                                                threats?</p>
                                            <p>If you have a positive score then congratulations,
                                                you seem to have a potentially positive opportunity.
                                                However, you will need to make sure that you have
                                                really considered whether this is the true picture.
                                                Have you fully considered the potential risks and
                                                threats? It may be worth reviewing your analysis to
                                                make sure. If you have a negative overall balance
                                                then this suggests that you have a number of either
                                                risks or threats to counter.</p>
                                            <p>Having completed the worksheet, you should have more
                                                of an idea of what kind of balance you’re achieving.
                                                You can use the data in these tables in many
                                                different ways; for example:</p>
                                            <div className="lightgreencontentbg lightbgcenter">
                                                <ol className="greenbullet-list color-sep">
                                                    <li style={{paddingLeft:'5px'}}
                                                        className="line-height1"><p>Identifying the
                                                        ‘highs’ and ‘lows’ on the positive and
                                                        negative indicators, to work out their
                                                        implications for management issues, team
                                                        contributions or other work situations.</p>
                                                    </li>
                                                    <li style={{paddingLeft:'5px'}}
                                                        className="line-height1"><p>Understanding
                                                        the strength of your own biases – and
                                                        planning a strategy to manage them.</p></li>
                                                    <li className="cntareap uiheading line-height1"
                                                        style={{paddingLeft:'5px'}}><p>A starting
                                                        point for discussions with others about your
                                                        decision making, and how you could balance
                                                        your approach.</p></li>
                                                </ol>
                                            </div>
                                            <br/>
                                            <p>A word of caution! The SWOT analysis can be very
                                                subjective, so don’t rely on it alone. It’s rare
                                                that two people produce the same SWOT analysis
                                                of the same situation. Use it as a guide
                                                only.</p>
                                            <div className="left-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page5')}
                                                    className="button-next-previous-done thought">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div
                                                    onClick={this.props.handleChangePage('Page7')}
                                                    className="button-next-previous-done thought">Next &gt;&gt;</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}